import {
  Component,
  Input,
  NgZone,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ManualDownloadedDataPoint,
  ManualsDownloadedData,
  ExportService,
  LoggingService,
  ToastrService,
} from "app/shared";
import { ManualsDownloadedConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";

@Component({
  selector: "manuals-downloaded-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class ManualsDownloadedChartComponent
  extends BaseChartLogic<ManualsDownloadedConfig, ManualsDownloadedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      ManualsDownloadedConfig,
      _ngZone
    );

    this.handleDataSubscription(
      this.analyticsService.manualsDownloadedDataChange
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: ManualDownloadedDataPoint): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.loggingService.log(
      "DownloadedManualsChartComponent - buildFilterSettings"
    );
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
    this.filterSettings.FilterByMinimum = this.config?.minDownloads || null;
  }

  refreshData(): void {
    this.loggingService.log("DownloadedManualsChartComponent - refreshData");
    this.analyticsService.getAllDownloadedManualsData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
